import { ConfirmationService } from 'primeng/api';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Toolbar } from '@modules/search/interfaces/interface';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { SpeedDialModule } from 'primeng/speeddial';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
import { SvgIconComponent } from '@ngneat/svg-icon';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [ButtonModule, SpeedDialModule,TooltipModule, ConfirmPopupModule,
    BadgeModule,SvgIconComponent
  ],
  providers: [ConfirmationService],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  @Input() toolbar: Toolbar[] = [];
  @Output() openEmailInfoEvent =  new EventEmitter<any>();

  constructor(
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
  }

  openEmailInfo( element: any) {
    // this.confirmationService.confirm({
    //   target: element.el.nativeElement as EventTarget ,
    //   key: 'emailInfoPopup'
    // });

    this.openEmailInfoEvent.emit(element);
  }


}
